import "./iconButton.css";
import { Icon } from "../icon";
import { IconButtonProps } from "./iconButton.props";

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  alt,
  onClick,
  variant = "default",
  disabled = false,
  className,
}) => {
  return (
    <button
      className={`icon-button ${variant} ${disabled ? "disabled" : ""} ${
        className ?? ""
      }`}
      onClick={onClick}
      disabled={disabled}
      title={alt}
    >
      <Icon icon={icon} alt={alt} className="icon-button-icon" />
    </button>
  );
};

export default IconButton;
